import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorViewAssignmentFeedback/PageProvider';
import { useContext } from 'react';
import { Dropdown, IconButton, MenuItem, Select, Stack, styled, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const Header = () => {
    const { device } = useViewport();

    const {
        currentFeedbackItem,
        feedbackItems,
        currentFeedbackItemIndex,
        students,
        currentStudentIndex,
        studentsWithoutFeedback,
        onClickBack,
        onChangeStudent,
        onClickPrevStudent,
        onClickNextStudent,
        onClickPrevAttempt,
        onClickNextAttempt,
        onSelect,
    } = useContext(PageContext);

    return (
        <>
            <RootStack
                alignItems={device === 'mobile' ? 'flex-end' : 'center'}
                device={device}
                direction={device === 'mobile' ? 'column-reverse' : 'row'}
                justifyContent={'space-between'}
            >
                <Stack sx={{ width: '100%' }} alignItems={'flex-end'} direction={'row'} spacing={2}>
                    <CustomSelect
                        device={device}
                        label={`Viewing ${currentStudentIndex + 1}/${students.length} Students`}
                        labelId={'student-select'}
                        value={
                            students.find(
                                ({ owner_account_id }) => owner_account_id === currentFeedbackItem.owner_account_id
                            ).owner_account_id
                        }
                        onChange={(e) => onChangeStudent(e.target.value)}
                    >
                        {students.map((accountUser) => (
                            <MenuItem key={accountUser.owner_account_id} value={accountUser.owner_account_id}>
                                {getUserPreferredFullName(accountUser)}
                            </MenuItem>
                        ))}
                        {studentsWithoutFeedback.map((accountUser) => (
                            <MenuItem key={accountUser.owner_account_id} disabled value={accountUser.owner_account_id}>
                                {getUserPreferredFullName(accountUser)}
                            </MenuItem>
                        ))}
                    </CustomSelect>
                    <IconButton
                        aria-label={'view previous student'}
                        disabled={!currentStudentIndex}
                        kind={'chevronLeft'}
                        size={'medium'}
                        variant={'square'}
                        onClick={onClickPrevStudent}
                    />
                    <IconButton
                        aria-label={'view next student'}
                        disabled={currentStudentIndex === students.length - 1}
                        kind={'chevronRight'}
                        size={'medium'}
                        variant={'square'}
                        onClick={onClickNextStudent}
                    />
                </Stack>
                <IconButton
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClickBack}
                />
            </RootStack>
            {device !== 'desktop' && (
                <NavStack alignItems={'center'} device={device} direction={'row-reverse'} spacing={4}>
                    <Dropdown
                        id={'instant-feedback-dropdown'}
                        options={[
                            // { key: 'reset', value: 'Reset this attempt', icon: 'refresh' },
                            { key: 'copy', value: 'Copy all feedback', icon: 'copy' },
                            { key: 'delete', value: 'Delete all feedback', icon: 'delete' },
                        ]}
                        rootComponent={
                            <IconButton
                                aria-label={'more options'}
                                kind={'moreHorizontal'}
                                size={'small'}
                                variant={'square'}
                            />
                        }
                        onSelect={onSelect}
                    />
                    <Stack alignItems={'center'} direction={'row'} spacing={1}>
                        <IconButton
                            aria-label={'view previous attempt'}
                            disabled={!currentFeedbackItemIndex}
                            kind={'chevronLeft'}
                            size={'small'}
                            variant={'square'}
                            onClick={onClickPrevAttempt}
                        />
                        <Text>
                            Attempt {currentFeedbackItemIndex + 1}/{feedbackItems.length}
                        </Text>
                        <IconButton
                            aria-label={'view next attempt'}
                            disabled={currentFeedbackItemIndex === feedbackItems.length - 1}
                            kind={'chevronRight'}
                            size={'small'}
                            variant={'square'}
                            onClick={onClickNextAttempt}
                        />
                    </Stack>
                </NavStack>
            )}
        </>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '129px' : '81px',
        padding: device === 'desktop' ? theme.spacing(3, 5) : theme.spacing(3, 4),
        background: theme.palette.ensightful.primary[50],
    };
});

const CustomSelect = styled(Select)(({ device }) => {
    return {
        width: device === 'mobile' ? '100%' : '350px',
    };
});

const NavStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: device === 'mobile' ? '129px' : '81px',
        flexShrink: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: '41px',
        padding: theme.spacing(0, 4),
        background: theme.palette.ensightful.shades[0],
    };
});

export default Header;
